export default "__VITE_ASSET__CG9d7IfS__"